import React from 'react';

export default function OrganicDivider() {
    return (
        <span className="ps-home-categories__ornament" aria-hidden="true">
            <svg viewBox="0 0 280 48" fill="none" focusable="false">
                <path d="M6 24c28-1.5 61-1.5 99 0-38 .7-71 .7-99 0Zm268 0c-28-1.5-61-1.5-99 0 38 .7 71 .7 99 0Z" fill="#c6ac7c" />
                <path d="M34 28h58m96 0h58" stroke="#e3d5ba" strokeWidth=".65" strokeLinecap="round" />
                <circle cx="140" cy="24" r="20" fill="#f8f2e5" />
                <path d="M124 12a20 20 0 1 0 32 0" stroke="#bca06c" strokeWidth=".8" strokeLinecap="round" />
                <path d="M125 33a17 17 0 0 0 30 0" stroke="#dfcda8" strokeWidth=".6" strokeLinecap="round" />
                <path d="M140 32c-1-8-1-14 5-21" stroke="#506d45" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M139 24c-7-1-11-5-10-11 7 0 12 5 10 11Z" fill="#8a9b6b" />
                <path d="M142 19c-1-7 3-12 11-13 1 7-3 12-11 13Z" fill="#47684c" />
                <path d="m131 16 7 7m6-7 6-5" stroke="#f8f2e5" strokeWidth=".65" strokeLinecap="round" opacity=".7" />
                <path d="M139 31c-6-4-8 6 0 7v-7Z" fill="#b18b5c" />
                <path d="M141 31c6-4 8 6 0 7v-7Z" fill="#8d6744" />
                <path d="m112 22 2 2-2 2-2-2Zm56 0 2 2-2 2-2-2Z" fill="#b99b63" />
            </svg>
        </span>
    );
}
